import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=f6228f98&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6228f98')) {
      api.createRecord('f6228f98', component.options)
    } else {
      api.reload('f6228f98', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=f6228f98&", function () {
      api.rerender('f6228f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26Y53V2d45JhP/JS/comp/IncreaseNumber.vue"
export default component.exports